import React, { useEffect, useMemo, useState } from "react";
import { View, Text, TextInput, StyleSheet } from "react-native";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";

type Props = {
  onValidationChange?: (isValid: boolean) => void;
};

const ReceiveAmountStep: React.FC<Props> = ({ onValidationChange }) => {
  const receiverReceiveAmount = useSessionStore((s: SessionState) => s.receiverReceiveAmount);
  const referenceNumberSearchResult = useSessionStore((s: SessionState) => (s as any).referenceNumberSearchResult);
  const setReceiverReceiveAmount = useSessionStore((s: SessionState) => (s as any).setReceiverReceiveAmount);
  const validationError = useSessionStore((s: SessionState) => (s as any).receiveAmountValidationError);
  const setValidationError = useSessionStore((s: SessionState) => (s as any).setReceiveAmountValidationError);
  const [amount, setAmount] = useState<string>(receiverReceiveAmount || "");

  const parseAmount = (text: string): string => {
    const cleaned = text.replace(/[^0-9.]/g, "");
    const parts = cleaned.split(".");
    if (parts.length > 2) {
      return `${parts[0]}.${parts.slice(1).join("")}`;
    }
    return cleaned;
  };

  const isValid = useMemo(() => {
    const n = parseFloat(amount || "0");
    return !!amount && isFinite(n) && n > 0;
  }, [amount]);

  useEffect(() => {
    if (onValidationChange) {
      onValidationChange(isValid);
    }
  }, [isValid, onValidationChange]);

  const handleChange = (text: string) => {
    const next = parseAmount(text);
    setAmount(next);
    try { setReceiverReceiveAmount?.(next); } catch {}
    try { setValidationError?.(null); } catch {}
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>How much are you receiving? </Text>
      <View style={styles.inputGroup}>
        <Text style={styles.inputLabel}>Receive Amount</Text>
        <View style={styles.inputWrapper}>
          <TextInput
            style={styles.input}
            keyboardType="decimal-pad"
            placeholder="Receive Amount"
            value={amount}
            onChangeText={handleChange}
          />
        </View>
        {!!validationError && (
          <Text style={styles.error}>{validationError}</Text>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, backgroundColor: "#fff" },
  title: { fontSize: 22, fontWeight: "700", marginBottom: 12, color: "#111827" },
  inputGroup: { marginBottom: 20 },
  inputLabel: { fontSize: 16, fontWeight: "500", color: "#333", marginBottom: 8 },
  inputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  input: { flex: 1, fontSize: 16 },
  error: { color: "red", fontSize: 12, marginTop: 8 },
});

export default ReceiveAmountStep;


